// src/components/landing/GallerySection.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import img_gallery_center from '../../assets/images/landing/gallery-center.jpg';
import img_gallery_ceremony from '../../assets/images/landing/gallery-ceremony.jpg';
import img_gallery_class from '../../assets/images/landing/gallery-class.jpg';
import img_gallery_faculty from '../../assets/images/landing/gallery-faculty.jpg';
import img_gallery_lab from '../../assets/images/landing/gallery-lab.jpg';
import img_gallery_student from '../../assets/images/landing/gallery-student.jpg';
const IMAGES = [
  { src: img_gallery_class,    alt: 'Indian students in classroom',      gridRow: 'span 2' },
  { src: img_gallery_lab,      alt: 'Computer lab at BSS IT Mission',   gridRow: '' },
  { src: img_gallery_ceremony, alt: 'Indian certificate ceremony',      gridColumn: 'span 2' },
  { src: img_gallery_faculty,  alt: 'Indian faculty and students',      gridRow: '' },
  { src: img_gallery_student,  alt: 'Student at laptop',                gridRow: '' },
  { src: img_gallery_center,   alt: 'BSS IT Mission center',            gridRow: '' },
];

export default function GallerySection() {
  return (
    <Box id="gallery" sx={{ bgcolor: '#ffffff', py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 } }}>
      <Box sx={{ textAlign: 'center', mb: 7 }}>
        <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#1d6cf0', mb: 1.5 }}>
          Campus Life
        </Typography>
        <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.4rem' }, fontWeight: 900, color: '#1e293b', mb: 1.5 }}>
          Students. Centers. Success.
        </Typography>
        <Typography sx={{ color: '#64748b', fontSize: '0.95rem', maxWidth: 500, mx: 'auto', lineHeight: 1.75 }}>
          A glimpse into the BSS IT Mission learning experience across Kerala.
        </Typography>
      </Box>

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: 'auto',
        gap: 2,
        maxWidth: 1100,
        mx: 'auto',
      }}>
        {IMAGES.map((img, i) => (
          <motion.div
            key={img.fallback || img.src}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            style={{ gridRow: img.gridRow || undefined, gridColumn: img.gridColumn || undefined }}
          >
            <Box sx={{
              borderRadius: 4, overflow: 'hidden',
              border: '1px solid #e2eaf5',
              boxShadow: '0 4px 16px rgba(29,108,240,0.08)',
              height: img.gridRow === 'span 2' ? '100%' : 210,
              minHeight: 210,
              transition: 'transform 0.3s, box-shadow 0.3s',
              '&:hover': { transform: 'scale(1.025)', boxShadow: '0 16px 40px rgba(29,108,240,0.18)' },
            }}>
              <Box component="img" src={img.src} alt={img.alt}
                sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </Box>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
}
